import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { IMAGE_URL } from "constants/product-collection";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { getPlanRowType, PlanMetricRows } from "../../pinned-row-renderers";
import { getDisplayPlansOrTotals } from "../pinned-row-helpers";
import { DiffCell } from "./diff-cell";
import { TotalCell } from "./total-cell";
import { MutedCell } from "./muted-cell";
import { LabelCell } from "./label-cell";
import { PlanCell } from "./plan-cell";
import { RollupLabelCell } from "./rollup-label-cell";
import { IGridContext } from "../../../product-collection-grid-view";
import { DefaultLabelCell } from "../default/default-label-cell";
import { DefaultValueCell } from "../default/default-values-cell";
import { DEFAULT_VALUES_PINNED_ROW } from "../../../detail-list/helpers";

interface IProps extends ICellRendererParams {
    getPlanHelper?: (data: any, gridContext: IGridContext) => number;
    getTotalHelper?: (data: any, gridContext: IGridContext) => number;
}

class PinnedRowRenderer implements ICellRendererComp {
    declare component: ICellRendererComp;

    getRendererComponent(params: IProps): ICellRendererComp {
        const { node, data, colDef } = params;
        const { displayPlanMetrics, displayTotals } = getDisplayPlansOrTotals(data);

        const colType = Array.isArray(colDef.type) ? colDef.type[0] : colDef.type;
        const dataType = data?.type;
        if (colDef.colId === IMAGE_URL) {
            if (data?.plan) {
                return new LabelCell();
            } else if (data?.totalType) {
                const rollupLabelCell = new RollupLabelCell();
                return rollupLabelCell;
            } else if (dataType === DEFAULT_VALUES_PINNED_ROW) {
                return new DefaultLabelCell();
            }
        } else if (dataType === DEFAULT_VALUES_PINNED_ROW) {
            return new DefaultValueCell();
        } else if (
            [
                ColumnTypes.DoorBulkQuantity,
                ColumnTypes.AllDimensionTotal,
                ColumnTypes.AllocationDimensionTotal,
                ColumnTypes.ClassificationTotal,
                ColumnTypes.NestedDimensionTotal,
            ].includes(colType as ColumnTypes)
        ) {
            if (displayPlanMetrics) {
                const planRowType = getPlanRowType(node.rowIndex);
                switch (planRowType) {
                    case PlanMetricRows.Total:
                        return new TotalCell();
                    case PlanMetricRows.Diff:
                        return new DiffCell();
                    case PlanMetricRows.Plan:
                        return new PlanCell();
                    default:
                        break;
                }
            } else if (displayTotals) {
                return new TotalCell();
            }
        }

        return new MutedCell();
    }

    refresh(params: IProps): boolean {
        // set value into cell again
        this.component.refresh(params);

        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.component.getGui();
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.component = this.getRendererComponent(params);
        this.component.init(params);
    }
}

export { PinnedRowRenderer };
